/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const productStatusStyle = {
  productStatus: (theme: Theme)=> ({
    padding: "1rem",
    [theme.breakpoints.up("md")]: {
      padding: "1.5rem"
    }
  }),
  descriptionListValue: {
    marginLeft: "0.5rem"
  },
  section: {
    marginTop: "1.5rem"
  }
};
